/** Per-browser conveniences such as the chosen language. Storage can be unavailable (private mode,
 * blocked site data); a choice then lasts for this page view only. */
export function readStored(key: string): string | null {
  try {
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

export function writeStored(key: string, value: string | null): void {
  try {
    if (value === null) localStorage.removeItem(key)
    else localStorage.setItem(key, value)
  } catch {
    // Keeping the choice for this page view only is acceptable.
  }
}

/** Removes the entries whose keys match, such as a user's at logout. */
export function forgetStored(matches: (key: string) => boolean): void {
  try {
    for (const key of Object.keys(localStorage)) if (matches(key)) localStorage.removeItem(key)
  } catch {
    // Nothing was kept.
  }
}
